import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as config from "../../../constants/config";
import * as modelHelper from "../../../helpers/modelHelper";
import * as getterHelper from "../../../helpers/getterHelper";

import imgBarcode from "../../../resources/img/svgicons/barcode.svg";
import Modal from "../generic/Modal";
import Table, {TABLE_VARIANT_SECONDARY} from "../generic/Table";
import Button from "../generic/Button";

export default class CanisterBarcodeModalGamma extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeCanister: null
        };
    }

    getColorantByCanister = (canister) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleSaveBarcodeClick = () => {
        this.props.setCanisterBarcode(this.state.activeCanister, this.props.barcode);
        this.setState({activeCanister: null});
    };

    handleManualScanButtonClick = () => {
        this.props.showManualBarcodeScan(true);
    };

    getCanisterRgb = (canister, colorant) => {
        if (canister !== null && canister.colorant !== null && canister.colorant.rgb !== null) {
            return canister.colorant.rgb;
        }

        if (colorant !== null && colorant.rgb !== null) {
            return colorant.rgb;
        }

        return config.DEFAULT_RGB;
    };

    handleTableItemClick = (event) => {
        let activeItem = getterHelper.getObjectById(this.props.canisterList, Number(event.currentTarget.dataset.key));
        if (activeItem !== null) {
            this.props.setResetButton();
            this.setState({activeCanister: activeItem.id});
        }
    };

    getBarcodeButtons = (record) => {
        return this.state.activeCanister === record.id ? (
            <div className="col-6 flex flex-wrap flex-align-center">
                <Button
                    className="margin-left-5 force-show-svg"
                    svgBefore={imgBarcode}
                    onClick={this.handleManualScanButtonClick}
                />
                {this.props.barcode &&
                this.state.activeCanister === record.id &&
                this.props.barcode !== record.barcode ? (
                    <Button
                        className="btn margin-left-5"
                        label={<Translate value="general.save" />}
                        onClick={this.handleSaveBarcodeClick}
                    />
                ) : null}
            </div>
        ) : null;
    };

    getBarcodeRowItem = (record) => {
        return (
            <div className="flex flex-wrap" style={{lineHeight: 1}}>
                <div className="col-6  flex flex-align-center-vertical flex-wrap">
                    {this.props.barcode || record.barcode ? (
                        <span className="col-12" style={{wordBreak: "break-all"}}>
                            {this.props.barcode && this.state.activeCanister === record.id
                                ? this.props.barcode
                                : record.barcode}
                        </span>
                    ) : null}

                    {this.state.activeCanister === record.id && !(this.props.barcode || record.barcode) ? (
                        <Translate className="font-size-0_75em" value="customRedlikeSettings.scanCanisterBarcode" />
                    ) : null}
                </div>
                {this.getBarcodeButtons(record)}
            </div>
        );
    };

    getTableRows = () => {
        return this.props.canisterList
            .filter((record) => record.colorant !== null)
            .map((record) => {
                let colorant = record.colorant;

                if (colorant.rgb === null) {
                    colorant = this.getColorantByCanister(record);
                }
                let rgb = this.getCanisterRgb(record, colorant);
                return modelHelper.buildTableRow(
                    [
                        modelHelper.buildTableCell(
                            <div className="flex-align-center-vertical flex">
                                <div
                                    className="color-square"
                                    style={{
                                        backgroundColor: rgb
                                    }}
                                />
                                <div>{colorant === null ? record.colorant.name : colorant.name}</div>
                            </div>,
                            "font-size-1_75em"
                        ),
                        modelHelper.buildTableCell(record.colorant.id, "font-size-1_75em "),
                        modelHelper.buildTableCell(this.getBarcodeRowItem(record), "font-size-1_75em")
                    ],
                    (this.state.activeCanister === record.id ? "active" : "") +
                        " padding-15 flex flex-align-center-vertical",
                    record.id,
                    {"data-key": record.id, onClick: this.handleTableItemClick}
                );
            });
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.canister" />),
            modelHelper.buildTableCell(<Translate value="general.canisterId" />),
            modelHelper.buildTableCell(<Translate value="customRedlikeSettings.barcode" />)
        ]);
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-6")
        ];
    };

    getCanistersContent = () => {
        if (this.props.canisterList.length === 0) {
            return "";
        }
        return modelHelper.buildModalSection(
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                className="flex-child"
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    render() {
        if (!this.props.connected) {
            return (
                <Modal
                    tabId={this.props.tabId}
                    header={modelHelper.buildModalSection(
                        <Translate value="customRedlikeSettings.setCanisterBarcode" />
                    )}
                    content={modelHelper.buildModalSection(
                        <Translate className="font-size-1_5em" value="general.rccIsNotConnected" />,
                        "color-primary"
                    )}
                    onClose={this.handleCloseModalClick}
                />
            );
        }
        return (
            <Modal
                tabId={this.props.tabId}
                header={modelHelper.buildModalSection(<Translate value="customRedlikeSettings.setCanisterBarcode" />)}
                content={this.getCanistersContent()}
                styles={{minWidth: "60%"}}
                onClose={this.handleCloseModalClick}
            />
        );
    }
}
